export const RESET_SHIPPING_ISFETCHING = 'RESET_SHIPPING_ISFETCHING';
export const LIST_SHIPPING_REQUEST = 'LIST_SHIPPING_REQUEST';
export const SHIPPING_REQUESTING = 'SHIPPING_REQUESTING';
export const LIST_SHIPPING_SUCCESS = 'LIST_SHIPPING_SUCCESS';
export const RESET_SHIPPING_QUERY = 'RESET_SHIPPING_QUERY';
